import React, { useState } from 'react';
import { Table } from 'antd';
import useFetchData from './useFetchData.ts';
import { ColumnsType } from 'antd/es/table';

const MainTable: React.FC = () => {
  const csvFilePath = process.env.PUBLIC_URL + '/salaries.csv';
  const data = useFetchData(csvFilePath);
  const [selectedYear, setSelectedYear] = useState<number | null>(null);

  const columns: ColumnsType<any> = [
    {
      title: 'Year',
      dataIndex: 'year',
      sorter: (a, b) => a.year - b.year,
    },
    {
      title: 'Number of Total Jobs',
      dataIndex: 'totalJobs',
      sorter: (a, b) => a.totalJobs - b.totalJobs,
    },
    {
      title: 'Average Salary (USD)',
      dataIndex: 'averageSalary',
      sorter: (a, b) => a.averageSalary - b.averageSalary,
    },
  ];

  const processedData = data.reduce((acc, row) => {
    const year = row.work_year;
    if (!acc[year]) {
      acc[year] = { year, totalJobs: 0, totalSalary: 0 };
    }
    acc[year].totalJobs += 1;
    acc[year].totalSalary += parseFloat(row.salary_in_usd);
    return acc;
  }, {});

  const tableData = Object.values(processedData).map((item: any) => ({
    ...item,
    averageSalary: item.totalSalary / item.totalJobs,
  }));

  return (
    <>
      <Table
        columns={columns}
        dataSource={tableData}
        rowKey="year"
        onRow={(record) => ({
          onClick: () => setSelectedYear(record.year),
        })}
      />
      {selectedYear && <AggregatedJobTitlesTable year={selectedYear} data={data} />}
    </>
  );
};

const AggregatedJobTitlesTable: React.FC<{ year: number, data: any[] }> = ({ year, data }) => {
  const filteredData = data.filter(row => row.work_year === year);
  const jobCounts = filteredData.reduce((acc, row) => {
    const jobTitle = row.job_title;
    if (!acc[jobTitle]) {
      acc[jobTitle] = 0;
    }
    acc[jobTitle] += 1;
    return acc;
  }, {});

  const tableData = Object.keys(jobCounts).map(jobTitle => ({
    jobTitle,
    count: jobCounts[jobTitle],
  }));

  const columns: ColumnsType<any> = [
    {
      title: 'Job Title',
      dataIndex: 'jobTitle',
    },
    {
      title: 'Count',
      dataIndex: 'count',
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={tableData}
      rowKey="jobTitle"
      title={() => `Job Titles for ${year}`}
    />
  );
};

export default MainTable;
